import { render, staticRenderFns } from "./LifestyleBox.vue?vue&type=template&id=03bf4582&scoped=true"
import script from "./LifestyleBox.vue?vue&type=script&lang=js"
export * from "./LifestyleBox.vue?vue&type=script&lang=js"
import style0 from "./LifestyleBox.vue?vue&type=style&index=0&id=03bf4582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf4582",
  null
  
)

export default component.exports